import { Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { IssueTypePriority, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { IssuePriorityIcon } from "../Icons/IssuePriorityIcon"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type IssuePrioritySelectGroupProps = MenuSelectGroupProps<Stored<IssueTypePriority>> & {
	priorities: Stored<IssueTypePriority>[]
}

export const IssuePrioritySelectGroup = memo<IssuePrioritySelectGroupProps>((props) => {
	const { ref, priorities, ...rest } = props

	return (
		<Menu.SelectGroup<Stored<IssueTypePriority>> ref={ref} {...rest}>
			{priorities.map((priority) => (
				<SelectItemTemplate<Stored<IssueTypePriority>> key={priority.uuid} value={priority}>
					<IssuePriorityIcon priority={priority.uuid} />
					<Text className="truncate">{priority.name}</Text>
				</SelectItemTemplate>
			))}
		</Menu.SelectGroup>
	)
})
IssuePrioritySelectGroup.displayName = "IssuePrioritySelectGroup"
